import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=6b94bea4&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"
import style0 from "./Change.vue?vue&type=style&index=0&id=6b94bea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94bea4",
  null
  
)

export default component.exports